import { PointerEvent } from 'react';

import { WHATSAPP } from '../config/company';
import { Icon, LogoMark } from './Icon';

const NAV = [
  ['/#pay', 'What you can pay'],
  ['/#ejor', 'Ejor'],
  ['/#dash', 'Dash'],
  ['/#schedules', 'Schedules'],
  ['/#security', 'Security'],
  ['/#faq', 'FAQ'],
  ['/about', 'Company'],
];

// The underline follows the mouse: it draws in from the side the pointer came
// from and runs out the side it leaves by, so sliding along the menu to the
// left sweeps left, and to the right sweeps right. The direction comes from
// the pointer's movement (a fast mouse can enter a short link past its
// middle); when it isn't moving sideways, from which half of the link it's
// on. Without a mouse, it draws in from the left (global.css defaults).
let lastX: number | null = null;

function underline(entering: boolean) {
  return (event: PointerEvent<HTMLAnchorElement>) => {
    const link = event.currentTarget;
    // lastX is the previous pointermove (enter/leave fire before the move).
    const dx = lastX === null ? 0 : event.clientX - lastX;
    let rightward: boolean;
    if (Math.abs(dx) >= 1) {
      rightward = dx > 0;
    } else {
      const box = link.getBoundingClientRect();
      const onRightHalf = event.clientX >= box.left + box.width / 2;
      rightward = entering ? !onRightHalf : onRightHalf;
    }
    // Moving right: draw in from the left, run out to the right (and mirrored).
    link.style.setProperty('--underline-origin', rightward === entering ? 'left' : 'right');
  };
}
const onEnter = underline(true);
const onLeave = underline(false);
const track = (event: PointerEvent) => {
  lastX = event.clientX;
};
const forget = () => {
  lastX = null;
};

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        {/* The wordmark: the logo mark is the H of "Hethera". Once the page
            scrolls (header.is-scrolled), "ethera" folds away and the H turns
            into the app icon: lime on the dark tile. */}
        <a href="/" className="logo" aria-label="Hethera home">
          <span className="logo__h">
            <LogoMark crop color="currentColor" size={20} />
          </span>
          <span className="logo__word" aria-hidden="true">
            <span>ethera</span>
          </span>
        </a>
        <nav className="site-nav" aria-label="Main" onPointerMove={track} onPointerLeave={forget}>
          {NAV.map(([href, label]) => (
            <a key={href} href={href} onPointerEnter={onEnter} onPointerLeave={onLeave}>
              {label}
            </a>
          ))}
        </nav>
        <a className="btn btn-dark" href={WHATSAPP.href}>
          Chat on WhatsApp
          <Icon name="arrow" size={16} />
        </a>
      </div>
    </header>
  );
}
